import { Form, Input, InputNumber } from "antd"



const CurrencyForm = () => {



    return (
    <>
        <Form.Item
              name="name"
              label="name"
              rules={[
                {
                  required: true,
                  message: "Please fill this field",
                },
              ]}
            >
              <Input placeholder="name" />
            </Form.Item>
            <Form.Item
              name="amount"
              label="amount"
              rules={[
                {
                  required: true,
                  message: "Please fill this field",
                },
              ]}
            >
              <InputNumber style={{
        width: '100%',
      }} placeholder="amount" />
            </Form.Item>
    </>
  )
}

export default CurrencyForm